import { Theme } from "@shared/lib/constants/themes";
import { readonly } from "vue";

export const courtMap = readonly(new Map<keyof typeof Theme, {
  name: string,
  address: string,
  location: string,
}>([
  [
    "AtlantaHawks",
    {
      name: "State Farm Arena",
      address: "1 State Farm Dr, Atlanta, GA 30303",
      location: "Atlanta, GA",
    },
  ],
  [
    "BostonCeltics",
    {
      name: "TD Garden",
      address: "100 Legends Way, Boston, MA 02114",
      location: "Boston, MA",
    },
  ],
  [
    "BrooklynNets",
    {
      name: "Barclays Center",
      address: "620 Atlantic Ave, Brooklyn, NY 11217",
      location: "Brooklyn, NY",
    },
  ],
  [
    "CharlotteHornets",
    {
      name: "Spectrum Center",
      address: "333 E Trade St, Charlotte, NC 28202",
      location: "Charlotte, NC",
    },
  ],
  [
    "ChicagoBulls",
    {
      name: "United Center",
      address: "1901 W Madison St, Chicago, IL 60612",
      location: "Chicago, IL",
    },
  ],
  [
    "ClevelandCavaliers",
    {
      name: "Rocket Arena",
      address: "1 Center Ct, Cleveland, OH 44115",
      location: "Cleveland, OH",
    },
  ],
  [
    "DallasMavericks",
    {
      name: "American Airlines Center",
      address: "2500 Victory Ave, Dallas, TX 75219",
      location: "Dallas, TX",
    },
  ],
  [
    "DenverNuggets",
    {
      name: "Ball Arena",
      address: "1000 Chopper Cir, Denver, CO 80204",
      location: "Denver, CO",
    },
  ],
  [
    "DetroitPistons",
    {
      name: "Little Caesars Arena",
      address: "2645 Woodward Ave, Detroit, MI 48201",
      location: "Detroit, MI",
    },
  ],
  [
    "GoldenStateWarriors",
    {
      name: "Chase Center",
      address: "1 Warriors Way, San Francisco, CA 94158",
      location: "San Francisco, CA",
    },
  ],
  [
    "HoustonRockets",
    {
      name: "Toyota Center",
      address: "1510 Polk St, Houston, TX 77002",
      location: "Houston, TX",
    },
  ],
  [
    "IndianaPacers",
    {
      name: "Gainbridge Fieldhouse",
      address: "125 S Pennsylvania St, Indianapolis, IN 46204",
      location: "Indianapolis, IN",
    },
  ],
  [
    "LosAngelesClippers",
    {
      name: "Intuit Dome",
      address: "3930 W Century Blvd, Inglewood, CA 90303",
      location: "Inglewood, CA",
    },
  ],
  [
    "LosAngelesLakers",
    {
      name: "Crypto.com Arena",
      address: "1111 S Figueroa St, Los Angeles, CA 90015",
      location: "Los Angeles, CA",
    },
  ],
  [
    "MemphisGrizzlies",
    {
      name: "FedExForum",
      address: "191 Beale St, Memphis, TN 38103",
      location: "Memphis, TN",
    },
  ],
  [
    "MiamiHeat",
    {
      name: "Kaseya Center",
      address: "601 Biscayne Blvd, Miami, FL 33132",
      location: "Miami, FL",
    },
  ],
  [
    "MilwaukeeBucks",
    {
      name: "Fiserv Forum",
      address: "1111 Vel R. Phillips Ave, Milwaukee, WI 53203",
      location: "Milwaukee, WI",
    },
  ],
  [
    "MinnesotaTimberwolves",
    {
      name: "Target Center",
      address: "600 N 1st Ave, Minneapolis, MN 55403",
      location: "Minneapolis, MN",
    },
  ],
  [
    "NewOrleansPelicans",
    {
      name: "Smoothie King Center",
      address: "1501 Dave Dixon Dr, New Orleans, LA 70113",
      location: "New Orleans, LA",
    },
  ],
  [
    "NewYorkKnicks",
    {
      name: "Madison Square Garden",
      address: "4 Pennsylvania Plaza, New York, NY 10001",
      location: "New York, NY",
    },
  ],
  [
    "OklahomaCityThunder",
    {
      name: "Paycom Center",
      address: "100 W Reno Ave, Oklahoma City, OK 73102",
      location: "Oklahoma City, OK",
    },
  ],
  [
    "OrlandoMagic",
    {
      name: "Kia Center",
      address: "400 W Church St, Orlando, FL 32801",
      location: "Orlando, FL",
    },
  ],
  [
    "Philadelphia76ers",
    {
      name: "Xfinity Mobile Arena",
      address: "3601 S Broad St, Philadelphia, PA 19148",
      location: "Philadelphia, PA",
    },
  ],
  [
    "PhoenixSuns",
    {
      name: "PHX Arena",
      address: "201 E Jefferson St, Phoenix, AZ 85004",
      location: "Phoenix, AZ",
    },
  ],
  [
    "PortlandTrailBlazers",
    {
      name: "Moda Center",
      address: "1 N Center Court St, Portland, OR 97227",
      location: "Portland, OR",
    },
  ],
  [
    "SacramentoKings",
    {
      name: "Golden 1 Center",
      address: "500 David J Stern Walk, Sacramento, CA 95814",
      location: "Sacramento, CA",
    },
  ],
  [
    "SanAntonioSpurs",
    {
      name: "Frost Bank Center",
      address: "1 Frost Bank Center Dr, San Antonio, TX 78219",
      location: "San Antonio, TX",
    },
  ],
  [
    "TorontoRaptors",
    {
      name: "Scotiabank Arena",
      address: "40 Bay St, Toronto, ON M5J 2X2, Canada",
      location: "Toronto, ON",
    },
  ],
  [
    "UtahJazz",
    {
      name: "Delta Center",
      address: "301 S Temple, Salt Lake City, UT 84101",
      location: "Salt Lake City, UT",
    },
  ],
  [
    "WashingtonWizards",
    {
      name: "Capital One Arena",
      address: "601 F St NW, Washington, DC 20004",
      location: "Washington, DC",
    },
  ],
  [
    "ChicagoSky",
    {
      name: "Wintrust Arena",
      address: "200 E Cermak Rd, Chicago, IL 60616",
      location: "Chicago, IL",
    },
  ],
  [
    "ConnecticutSun",
    {
      name: "Mohegan Sun Arena",
      address: "1 Mohegan Sun Blvd, Uncasville, CT 06382",
      location: "Uncasville, CT",
    },
  ],
  [
    "DallasWings",
    {
      name: "College Park Center",
      address: "600 S Center St, Arlington, TX 76019",
      location: "Arlington, TX",
    },
  ],
  [
    "IndianaFever",
    {
      name: "Gainbridge Fieldhouse",
      address: "125 S Pennsylvania St, Indianapolis, IN 46204",
      location: "Indianapolis, IN",
    },
  ],
  [
    "LasVegasAces",
    {
      name: "Michelob Ultra Arena",
      address: "3950 S Las Vegas Blvd, Las Vegas, NV 89119",
      location: "Las Vegas, NV",
    },
  ],
  [
    "LosAngelesSparks",
    {
      name: "Crypto.com Arena",
      address: "1111 S Figueroa St, Los Angeles, CA 90015",
      location: "Los Angeles, CA",
    },
  ],
  [
    "MinnesotaLynx",
    {
      name: "Target Center",
      address: "600 N 1st Ave, Minneapolis, MN 55403",
      location: "Minneapolis, MN",
    },
  ],
  [
    "NewYorkLiberty",
    {
      name: "Barclays Center",
      address: "620 Atlantic Ave, Brooklyn, NY 11217",
      location: "Brooklyn, NY",
    },
  ],
  [
    "PhoenixMercury",
    {
      name: "PHX Arena",
      address: "201 E Jefferson St, Phoenix, AZ 85004",
      location: "Phoenix, AZ",
    },
  ],
  [
    "SeattleStorm",
    {
      name: "Climate Pledge Arena",
      address: "334 1st Ave N, Seattle, WA 98109",
      location: "Seattle, WA",
    },
  ],
  [
    "WashingtonMystics",
    {
      name: "CareFirst Arena",
      address: "1100 Oak Dr SE, Washington, DC 20032",
      location: "Washington, DC",
    },
  ],
  [
    "GoldenStateValkyries",
    {
      name: "Chase Center",
      address: "1 Warriors Way, San Francisco, CA 94158",
      location: "San Francisco, CA",
    },
  ],
]));
